import React from 'react';
import {
  CardPreviewContent,
  CTAWrapper,
  ModalContentWrapper,
  NewTrainingButton,
} from '../atoms/styles';
import { Dialog } from '@material-ui/core';
import {
  FontAwesomeSpriteButton,
  FontAwesomeSpriteIcon,
} from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight, SpriteIconsSolid } from 'src/config/api/models/FontAwesome';
import theme from 'src/config/theme';
import { CardContent } from './CardContent';
import useKeyPress from '../../hooks/useKeyPress';
import { useUser } from 'src/modules/shared';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import {
  StudyCardsTypes,
  useGetStudyCardsQuery,
} from 'src/modules/shared/slices/study-card/api/studyCard';
import { setCurrentPreviewCardIndex } from 'src/modules/shared/slices/study-card/entity/StudyCardSlice';
import { useGetPagesQuery } from 'src/modules/shared/slices/page/api/pages';
import { trajectorySectionCodeLookup } from 'src/config/api/models/Trajectory';

type CardPreviewProps = {
  type: StudyCardsTypes;
  onClose: () => void;
  onOpenForm: () => void;
  onEditCard: () => void;
};

export const CardPreview: React.FC<CardPreviewProps> = ({
  type,
  onClose,
  onOpenForm,
  onEditCard,
}) => {
  const { isAuthor, isSuperAdmin, isAdmin } = useUser();
  const dispatch = useAppDispatch();
  const currentPreviewCardIndex = useAppSelector(
    (state) => state.studyCard.currentPreviewCardIndex
  );
  const trajectoryId = useAppSelector((state) => state.trajectories.currentTrajectoryId);
  const viewMode = useAppSelector((state) => state.trajectories.viewMode);
  const { data: pageData } = useGetPagesQuery({
    trajectoryId: trajectoryId!,
    type: trajectorySectionCodeLookup['3'],
  });

  const pageId = pageData?.find((item) => item.type === trajectorySectionCodeLookup['3'])?.id;
  const { data: cards } = useGetStudyCardsQuery(
    {
      cardType: type,
      pageId: pageId as string,
    },
    { skip: !pageId }
  );

  const showNextCard = useKeyPress;
  const showPreviousCard = useKeyPress;

  const handlePreviousCard = () => {
    return dispatch(setCurrentPreviewCardIndex(currentPreviewCardIndex - 1));
  };

  const handleNextCard = () => {
    if (cards && currentPreviewCardIndex === cards?.length - 1) return onClose();
    return dispatch(setCurrentPreviewCardIndex(currentPreviewCardIndex + 1));
  };

  showPreviousCard('ArrowLeft', handlePreviousCard);
  showNextCard('ArrowRight', handleNextCard);

  const userCanEdit = (isAuthor || isSuperAdmin || isAdmin) && viewMode === 'edit';

  if (!cards) return null;

  return (
    <>
      <Dialog
        open={true}
        onClose={onClose}
        scroll="body"
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            width: 'fit-content',
            overflow: 'visible',
            maxWidth: 'unset',
          },
          elevation: 0,
        }}
        style={{ backgroundColor: 'transparent' }}
      >
        <ModalContentWrapper>
          <div>
            {currentPreviewCardIndex > 0 && (
              <FontAwesomeSpriteButton
                icon={SpriteIconsSolid.CHEVRON_LEFT}
                iconSize="1x"
                color={theme.palette.common.white}
                buttonStyle={{
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: theme.config.defaultBorderRadius,
                }}
                onClick={() => handlePreviousCard()}
              />
            )}
          </div>
          <CardPreviewContent>
            <CardContent onClose={onClose} card={cards[currentPreviewCardIndex]} />
          </CardPreviewContent>
          <div>
            <FontAwesomeSpriteButton
              icon={
                currentPreviewCardIndex === cards?.length - 1
                  ? SpriteIconsSolid.XMARK
                  : SpriteIconsSolid.CHEVRON_RIGHT
              }
              iconSize="1x"
              color={theme.palette.common.white}
              buttonStyle={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: theme.config.defaultBorderRadius,
              }}
              onClick={() => handleNextCard()}
            />
          </div>
        </ModalContentWrapper>
        <CTAWrapper>
          <NewTrainingButton
            onClick={() => {
              onClose();
              if (userCanEdit) {
                onEditCard();
              } else {
                onOpenForm();
              }
            }}
            startIcon={
              <FontAwesomeSpriteIcon iconSize="sm" color="white" icon={SpriteIconsLight.BRAIN} />
            }
          >
            {userCanEdit ? 'Kaart bewerken' : 'Nu trainen'}
          </NewTrainingButton>
        </CTAWrapper>
      </Dialog>
    </>
  );
};
